import { useHistory, useParams } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { coursePaths } from "@circle-react/helpers/urlHelpers";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { Layout, useCustomizeUIData } from "@circle-react-shared/CustomizeUI";
import { ExitButton } from "@circle-react-shared/CustomizeUI/Header/ExitButton";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

export interface EditLessonHeaderProps {
  isDisabled?: boolean;
  isSaving?: boolean;
}

interface ParamsShape {
  lessonId: string;
  sectionId: string;
}

export const EditLessonHeader = ({
  isSaving = false,
  isDisabled = false,
}: EditLessonHeaderProps) => {
  const { setCurrentSection } = useCustomizeUIData();
  const history = useHistory();
  const spaceContext = useCurrentSpaceContext();
  const spaceSlug = spaceContext.data?.slug || "";
  const { lessonId, sectionId } = useParams<ParamsShape>();
  const isSmScreen = useSmScreenMediaQuery();

  const goBackToSpace = () => {
    history.push(`/c/${spaceSlug}`);
    setCurrentSection(t("customize_space.lessons"));
  };

  const goToLesson = () => {
    history.push(
      coursePaths.showLesson({
        lessonId,
        sectionId,
        spaceSlug,
      }),
    );
  };

  return (
    <Layout.Header className="flex items-center justify-between px-4 md:px-6">
      <div className="flex items-center space-x-4">
        <ExitButton onClick={goBackToSpace} />
        {!isSmScreen && (
          <Typography.LabelMd weight="semibold">
            {t("courses.edit.lesson.back_to_lessons")}
          </Typography.LabelMd>
        )}
      </div>
      <div className="flex items-center space-x-4">
        <Button type="button" variant="secondary" onClick={goToLesson}>
          {isSmScreen
            ? t("courses.edit.lesson.view")
            : t("courses.edit.lesson.view_lesson")}
        </Button>
        <Button
          disabled={isDisabled || isSaving}
          type="submit"
          form="edit-lesson-form"
          variant="circle"
        >
          {isSaving
            ? t("courses.edit.lesson.saving")
            : t("courses.edit.lesson.save")}
        </Button>
      </div>
    </Layout.Header>
  );
};
